<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
           
            <div class="col-sm-6"></div><!-- /.col -->
           
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">Agent Invoices</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <div class="row">
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <div class="row">
            <div class="col">
                <input type="text" class="form-control" placeholder="Type Invoice No. ,BL No. ,Consignee or Agent here to search..." (input)="onSearchTextChange($event)">
            </div>
        </div>
      </div>
    </div>
    </section>
      <!-- /.content-header -->
    <section class="content">
      <div class="container-fluid">
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Agent Invoices</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body" style="overflow-x: auto; white-space: nowrap;">
               <!--Error messages here-->
            <table id="example1" class="table table-bordered table-hover">
              <thead>
                <tr>
                    <th>Consignee</th>
                    <th>Agent</th>
                    <th>BL No.</th>
                    <th>No. of Units</th>
                    <th>Invoice No.</th>
                    <th>Amount</th>
                    <th>VAT</th>
                    <th>Total</th>
                    <th>Withholding Tax</th>
                    <th>Withholding VAT</th>
                    <th>Amount Payable</th>
                    <th>Balance Due</th>
                    <th></th>
                </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let invoice of invoices | searchAgencyFeeInvoices: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }">
                      <td>{{invoice.consignee}}</td>
                      <td>{{invoice.agent}}</td>
                      <td>{{invoice.bl_no}}</td>
                      <td>{{invoice.no_of_units}}</td>
                      <td>{{invoice.invoice_no}}</td>
                      <td>{{invoice.amount|currency:' '}}</td>
                      <td>{{invoice.vat|currency:' '}}</td>
                      <td>{{invoice.total|currency:' '}}</td>
                      <td>{{invoice.withholding_tax|currency:' '}}</td>
                      <td *ngIf="invoice.withholding_vat==0"></td>
                      <td *ngIf="invoice.withholding_vat>0">{{invoice.withholding_vat|currency:' '}}</td>
                      <td>{{invoice.amount_payable|currency:' '}}</td>
                      <td>{{invoice.balance|currency:' '}}</td>
                      <td>
                        <div class="dropdown">
                            <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">Action<span class="caret"></span></button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" routerLink="/pay-agents/{{invoice.invoice_id}}">Pay</a></li>
                                <li *ngIf="invoice.file_type==='image'"><a class="dropdown-item" routerLink="/preview-agency-fee-invoice/{{invoice.invoice_id}}">View Attachment</a></li>
                                <li *ngIf="invoice.file_type==='pdf'"><a class="dropdown-item" target="_blank" href="{{invoice.attachment}}">View Attachment</a></li>
                            </ul>
                        </div>
                      </td>
                  </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
    </section>